import { LicenseType } from '@ebalance/proto/bfftypes/v1/license_type_pb'
import type {
  BgMasterListItem,
  SubmitterMasterListItem,
} from '@ebalance/proto/bffuser/v1/occto_master_model_pb'

export type WorkflowTargetCodeFilterOption = {
  code: string
  name: string
}

export function buildWorkflowTargetCodeFilterOptions(
  bgMasters: ReadonlyArray<Pick<BgMasterListItem, 'bgCode' | 'bgName'>>,
  submitterMasters: ReadonlyArray<
    Pick<
      SubmitterMasterListItem,
      'submitterCode' | 'submitterName' | 'licenseType'
    >
  >,
): WorkflowTargetCodeFilterOption[] {
  const options = new Map(
    bgMasters.map((bg) => [bg.bgCode, { code: bg.bgCode, name: bg.bgName }]),
  )
  for (const submitter of submitterMasters) {
    if (submitter.licenseType === LicenseType.GENERATION) {
      options.set(submitter.submitterCode, {
        code: submitter.submitterCode,
        name: submitter.submitterName,
      })
    }
  }
  return [...options.values()]
}
